export default __webpack_public_path__ + "static/food_nutrition-c77389aeffaf2eb3defb1232447cba28.png";